export default __webpack_public_path__ + "static/media/computer-with-graph.74b0a198.jpg";